import getTopics from 'services/apiHelpers/getTopics';
import getInteractionsInTopic from 'services/apiHelpers/getInteractionsInTopic';
import { moduleNavigationActionsList } from 'components/NavigationSettings/ModuleNavigation';

const hasValidLocationUpdated = location => {
  if (!location) {
    return undefined;
  }

  if (
    moduleNavigationActionsList.includes(location) ||
    location.match('http')
  ) {
    return true;
  }

  //

  //
  let parsedLocation = location.replace(/#/, '').split('/');

  const [topicSId, interactionSId] = parsedLocation;

  const topics = getTopics();
  const topic = topics.find((t: any) => {
    const tSId = t.props.sId || t.id;
    const found = tSId == topicSId;

    return found;
  });

  if (!topic) {
    return false;
  }

  const interactions = getInteractionsInTopic(topic);
  const interaction = interactions.find((i: any) => {
    const iSId = i.props.sId || i.id;
    const found = iSId == interactionSId;

    return found;
  });

  return interaction ? true : false;
};

export default hasValidLocationUpdated;
